module.exports = __webpack_public_path__ + "sunsemweb/img/al.8742c1f9.png";